export const SOCKET_EVENTS = {
	// ACCESS_CONTROL_EVENTS
	GRANTED_PERMISSION: 'prmGranted',
	REVOKED_PERMISSION: 'prmRevoked',
	ACCESS_EVENT: 'accessEvent',
	KIOSK_EVENT: 'kioskEvent',
	//DEVICE_EVENTS
	DEVICE_EVENT: 'device',
	ADD_DEVICE_EVENT: 'addDevice',
	//BOOKINGS_EVENTS
	LOCKER_BOOKING_CREATED: 'lockerBookingCreated',
	LOCKER_BOOKING_DELETED: 'lockerBookingDeleted',
	LOCKER_BOOKED_BY_PERSON: 'lockerBookedByPerson',
	LOCKER_RELEASED_BY_PERSON: 'lockerReleasedByPerson',

	//SETTINGS_EVENTS
	SETTING_ENABLE_ACCESS_CONTROL: 'settingEnableAccessControl',
	SETTING_DISABLE_ACCESS_CONTROL: 'settingDisableAccessControl',
	SETTING_ENABLE_MODULE_LOCKER: 'settingEnableModuleLocker',
	SETTING_DISABLE_MODULE_LOCKER: 'settingDisableModuleLocker',

	//PERSON_EVENTS
	PERSON_ADDED: 'personAdded',
	PERSON_UPDATED: 'personUpdated',
	PERSON_DELETED: 'personDeleted',
	PERSON_ENABLED: 'personEnabled',
	PERSON_DISABLED: 'personDisabled',

	//LOGGING_EVENTS
	LOG_ACCESS_EVENT: 'log:access:event',
	LOG_SYNC_COMPLETE: 'log:sync:complete',

	// SYNC_EVENTS
	SYNC_PROGRESS: 'sync:progress',
	SYNC_COMPLETE: 'sync:complete',
	SYNC_ERROR: 'sync:error',

	// BULK_CREDENTIAL_EVENTS
	CREDENTIAL_BULK_PROGRESS: 'credential:bulk:progress',
	CREDENTIAL_BULK_COMPLETE: 'credential:bulk:complete',
	CREDENTIAL_BULK_ERROR: 'credential:bulk:error',

	// CREDENTIAL_PROPAGATION_EVENTS
	CREDENTIAL_PROPAGATION_QUEUED: 'credential:propagation:queued',
	CREDENTIAL_PROPAGATION_STARTED: 'credential:propagation:started',
	CREDENTIAL_PROPAGATION_PROGRESS: 'credential:propagation:progress',
	CREDENTIAL_PROPAGATION_COMPLETE: 'credential:propagation:complete'
};
